import { useSyncExternalStore } from "react";
import { getMyRequests, subscribeMyRequests, type MyRequestEntry } from "./myRequests.js";

const EMPTY: MyRequestEntry[] = [];

/** Live view of `myRequests.ts`'s localStorage list — no network involved. */
export function useMyRequests(): MyRequestEntry[] {
  return useSyncExternalStore(subscribeMyRequests, getMyRequests, () => EMPTY);
}
